import CookieService from "../services/cookie.service";

/**
 * Process RP service URLs and return create account and reset password URLs
 * @param {Array} response - Array of service URL objects
 * @param {Object} options - Configuration options
 * @param {string} options.loyaltyFormFlag - Loyalty form flag value
 * @param {string} options.registrationType - Registration type (e.g., 'FULL')
 * @returns {Object} - Object containing processed URLs and rpUrls array
 */
export const processServiceUrls = (response, options = {}) => {
  const { loyaltyFormFlag, registrationType } = options;
  
  let createAccountUrl = "/global-registration/registration";
  let resetPwdUrl = "/identity/account/reset-password/v2/request";
  let rpUrls = [];

  if (Array.isArray(response)) {
    rpUrls = response;
    
    response.forEach((obj) => {
      if (obj.serviceName === "createAccount") {
        createAccountUrl = obj.url;
      } else if (obj.serviceName === "resetPassword") {
        resetPwdUrl = obj.url;
      }
    });

    // Handle loyalty form or FULL registration type
    if (loyaltyFormFlag === "1" || registrationType === "FULL") {
      const loyaltyInfoValue = JSON.parse(
        CookieService.getCookie("CK_LOYALTY_INFO") || "null"
      );
      if (loyaltyInfoValue) {
        loyaltyInfoValue.callType = "TfCommerce";
        CookieService.setCookie(
          "CK_LOYALTY_INFO",
          JSON.stringify(loyaltyInfoValue),
          1
        );
      }
      createAccountUrl = "/global-registration/aspire";
      resetPwdUrl = "/identity/account/reset-password/request";
    }
  }

  return {
    createAccountUrl,
    resetPwdUrl,
    rpUrls
  };
};

/**
 * Check if current page is a cloud flow page
 * @returns {boolean}
 */
export const isCloudFlow = () => {
  return window.location.href.includes("cloud-");
};

/**
 * Get stored RP URLs from session storage
 * @returns {Array|null}
 */
export const getStoredRpUrls = () => {
  try {
    const stored = sessionStorage.getItem("rp_url");
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error("Error parsing stored RP URLs:", error);
    return null;
  }
};

/**
 * Store RP URLs in session storage
 * @param {Array} rpUrls - RP URLs array to store
 */
export const storeRpUrls = (rpUrls) => {
  if (Array.isArray(rpUrls) && rpUrls.length > 1) {
    sessionStorage.setItem("rp_url", JSON.stringify(rpUrls));
  }
};

/**
 * Get service URL by service name from rpUrls array
 * @param {Array} rpUrls - Array of service URL objects
 * @param {string} serviceName - Name of the service (e.g., 'createAccount', 'resetPassword')
 * @returns {string|null}
 */
export const getServiceUrl = (rpUrls, serviceName) => {
  if (!Array.isArray(rpUrls)) return null;
  const service = rpUrls.find(obj => obj.serviceName === serviceName);
  return service ? service.url : null;
};
